<template>
    <div class="lg:bg-foxy-surface/80 lg:backdrop-blur-xl rounded-3xl lg:shadow-xl lg:border border-foxy-border/80 lg:p-8 text-foxy-text">
        <div class="flex items-center justify-between mb-6">
            <h3 class="text-2xl font-bold text-foxy-text flex items-center">
                Порівняйте ціни
            </h3>
        </div>

        <div v-if="prices && prices.length > 0" class="space-y-4">
            <div v-for="price in sortedPrices" :key="price.id" 
                 class="bg-foxy-surface/80 rounded-xl p-4 lg:p-6 border border-foxy-border hover:shadow-md transition-all duration-200">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center justify-between">
                    <!-- Store Info -->
                    <div class="flex items-center space-x-4">
                        <!-- Store Logo -->
                        <div class="w-12 h-12 rounded-full bg-white dark:bg-foxy-elevated flex items-center justify-center shadow-sm">
                            <img v-if="price.bookstore.logo_url" 
                                 :src="price.bookstore.logo_url" 
                                 :alt="price.bookstore.name"
                                 loading="lazy"
                                 decoding="async"
                                 width="32"
                                 height="32"
                                 class="w-8 h-8 rounded-full object-cover">
                            <div v-else 
                                 class="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold text-lg">
                                {{ price.bookstore.name.charAt(0).toUpperCase() }}
                            </div>
                        </div>
                        
                        <!-- Store Details -->
                        <div>
                            <h4 class="text-lg font-semibold text-foxy-text">
                                {{ price.bookstore.name }}
                            </h4>
                            <p class="text-sm text-foxy-text-secondary">
                                {{ price.bookstore.description || 'Книжковий магазин' }}
                            </p>
                        </div>
                    </div>

                    <!-- Price and Link -->
                    <div class="flex items-center justify-between lg:justify-start space-x-4">
                        <!-- Price -->
                        <div class="text-left lg:text-right">
                            <div class="text-2xl font-bold text-foxy-text">
                                {{ price.formatted_price }}
                            </div>
                            <div v-if="!price.is_available" class="text-sm text-red-500 dark:text-red-400">
                                Немає в наявності
                            </div>
                            <div v-else class="text-sm text-green-500 dark:text-green-400">
                                В наявності
                            </div>
                        </div>

                        <!-- Link Button -->
                        <a :href="price.product_url" 
                           target="_blank" 
                           rel="noopener noreferrer"
                           class="bg-foxy-action hover:bg-foxy-action/90 text-white px-6 py-3 rounded-xl font-semibold transition-all duration-200 transform hover:scale-105 shadow-sm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-foxy-action/20">
                            На сайт
                        </a>
                    </div>
                </div>
            </div>

            <!-- Show More Button -->
            <div class="text-center pt-4">
                <button @click="showAllPrices = !showAllPrices"
                        class="text-foxy-text-secondary hover:text-foxy-text font-medium transition-colors rounded-lg focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-foxy-action/20">
                    {{ showAllPrices ? 'Показати менше' : 'Показати більше пропозицій' }}
                </button>
            </div>
        </div>

        <div v-else class="text-center py-8">
            <svg class="w-16 h-16 mx-auto text-foxy-border mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
            </svg>
            <p class="text-foxy-text-secondary text-lg">
                Ціни для цієї книги ще не додані
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PriceComparison',
    props: {
        prices: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showAllPrices: false,
            maxVisiblePrices: 3
        };
    },
    computed: {
        sortedPrices() {
            // Сортируем цены по возрастанию, доступные товары в начале
            const sorted = [...this.prices].sort((a, b) => {
                // Сначала доступные товары
                if (a.is_available && !b.is_available) return -1;
                if (!a.is_available && b.is_available) return 1;
                
                // Затем по цене
                return a.price - b.price;
            });

            // Показываем только первые maxVisiblePrices если не показаны все
            if (!this.showAllPrices && sorted.length > this.maxVisiblePrices) {
                return sorted.slice(0, this.maxVisiblePrices);
            }
            
            return sorted;
        }
    }
};
</script>
